import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MainFrontendConfigFieldAccess } from 'src/modules/app-template/netgen/MainFrontendConfigFieldAccess';
import { DatabaseUser } from 'src/modules/database/shared/database-user.entity';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { Objects } from "src/modules/utils/shared/objects";
import { EntityDefinition } from "../../models/entity-definition.model";
import { AdminBaseListComponent } from "../admin-base-list/admin-base-list.component";

@Component({
    selector: 'app-edit-general-users',
    templateUrl: '../../../sm-base/components/admin-base-list/admin-base-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditGeneralUsersComponent extends AdminBaseListComponent<DatabaseUser> {

    static staticDefinition = Objects.fromPlain(EntityDefinition<DatabaseUser>, {
        type: DatabaseUser,
        nameKey: "entity.DatabaseUser.entityName",
        namePluralKey: "entity.DatabaseUser.entityNamePlural",
        categoryKey: "entity.DatabaseUser.category",
        icon: "fas fa-user",
        apiEndpoint: "api/app/user",
        adminListUrl: "/base2/admin/editGeneralUsers"        
    });

    definition = Objects.with(Objects.fromPlain(EntityDefinition<DatabaseUser>, EditGeneralUsersComponent.staticDefinition), "canInsert", this.app.mainConfig.adminUsersAllowAdd);

    getTable(): TableData {
        return new TableData([
            new TableColumn("userName", this.app.t("entity.DatabaseUser.fields.userName"), TableCellType.string, 20),
            this.applyFieldAccess(new TableColumn("lastName", this.app.t("entity.DatabaseUser.fields.lastName"), TableCellType.string, 20)),
            this.applyFieldAccess(new TableColumn("firstName", this.app.t("entity.DatabaseUser.fields.firstName"), TableCellType.string, 20)),
            this.applyFieldAccess(new TableColumn("mail", this.app.t("entity.DatabaseUser.fields.mail"), TableCellType.string, 30)),
            this.applyFieldAccess(new TableColumn("phone", this.app.t("entity.DatabaseUser.fields.phone"), TableCellType.string, 15)),
            this.app.mainConfig.useAdminCompanies ? this.applyFieldAccess(new TableColumn("company", this.app.t("entity.DatabaseUser.fields.company"), TableCellType.string, 20)) : null,
            this.applyFieldAccess(new TableColumn("isAdmin", this.app.t("entity.DatabaseUser.fields.isAdmin"), TableCellType.bool, 1)),
            this.applyFieldAccess(new TableColumn("active", this.app.t("entity.DatabaseUser.fields.active"), TableCellType.bool, 1)),
            this.applyFieldAccess(new TableColumn("groups", this.app.t("entity.DatabaseUser.fields.groups"), TableCellType.string, 30))
        ], this.listData.map(o => new TableRow("", o, {
            userName: o.userName,
            lastName: o.lastName,
            firstName: o.firstName,
            mail: o.mail,
            phone: o.phone,
            company: o.company?.name ?? "",
            isAdmin: o.isAdmin,
            active: o.active,
            groups: Arrays.itemsToString(Arrays.sort(o.groups.map(g => g.name)))
        })), ["userName"]);
    }

    private applyFieldAccess(col: TableColumn): TableColumn {
        let fa = this.app.mainConfig.adminUsersFieldAccess;
        if (fa == null) {
            return col;
        }
        if (Objects.getSafe(fa, col.id, MainFrontendConfigFieldAccess.editable) == MainFrontendConfigFieldAccess.hidden) {
            return null;
        }
        return col;
    }

}
